import React from "react";
import { Button } from "react-bootstrap";

const CourseStart2: React.FC = () => {
   
    return(
      <>
      <Button  style={{ paddingTop: "25px", paddingBottom: "25px", background: "none", border: "none", fontSize: "1.5rem" }}>
        Not Available
      </Button>
    </>
    
    )
}

export default CourseStart2;